import {Component, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgIf, NgOptimizedImage} from "@angular/common";

@Component({
    selector: 'cdss-patient-registration-care-programme-modal',
    templateUrl: './patient-registration-care-programme-modal.component.html'
})
export class PatientRegistrationCareProgrammeModalComponent implements OnInit {

    title: string = ""
    subtitle: string = ""
    duration: string = ""
    description: string = ""
    thumbnailUrl: string = ""

    constructor(
        public activeModal: NgbActiveModal,
        public modal: NgbModal,
    ) {
    }

    ngOnInit() {
    }

    submit() {
        this.activeModal.close({});
    }

}
